import React, { useState } from 'react';
import { Typography, Button } from '@mui/material';
import { useTeamsTeamMembersDestroyMutation } from '../../../../services/GLOWClient';
import theme from '../../../../theme';
import MuiDialog from '../../../../SystemDesign/MuiDialog';
import DeleteIcon from '@mui/icons-material/Delete';

const DeleteMember = ({ open, onClose, member }) => {
    const [deleteTeamMember, { isLoading }] = useTeamsTeamMembersDestroyMutation();
    const [error, setError] = useState('');
    
    const handleDelete = async () => {
        try {
            setError('');
            const deleteData = { teamMemberId: member.team_member_id };
            
            await deleteTeamMember(deleteData).unwrap();
            
            // Close dialog on success
            onClose();
        } catch (error) {
            console.error('Error deleting team member:', error);
            // Handle specific error messages
            if (error.data?.error) {
                if (error.data.error.includes("NoneType' object has no attribute 'salon'")) {
                    setError("Impossible de supprimer un membre sans équipe. Veuillez d'abord l'assigner à une équipe.");
                } else {
                    setError(error.data.error);
                }
            } else {
                setError('Une erreur est survenue lors de la suppression du membre');
            }
        }
    };
    
    const dialogContent = (
        <div>
            {error && (
                <div style={{ color: theme.colors.error.main, marginBottom: '16px' }}>
                    {error}
                </div>
            )}
            
            <Typography variant="body1" gutterBottom>
                Êtes-vous sûr de vouloir supprimer ce membre d'équipe ?
            </Typography>
            
            <Typography variant="body2" style={{ color: theme.colors.error.main }}>
                Cette action est irréversible et supprimera définitivement le membre d'équipe.
            </Typography>
            
            <div style={{ marginTop: '16px' }}>
                <Typography variant="subtitle2" gutterBottom>
                    Détails du membre :
                </Typography>
                <Typography variant="body2">
                    <strong>Équipe :</strong> {member.team_name || 'Non assigné'}
                </Typography>
                <Typography variant="body2">
                    <strong>Utilisateur :</strong> {member.user_details?.full_name || member.user_details?.username || 'N/A'}
                </Typography>
                {member.specialities && (
                    <Typography variant="body2">
                        <strong>Spécialités :</strong> {
                            Array.isArray(member.specialities) 
                                ? member.specialities.join(', ') 
                                : Object.keys(member.specialities).join(', ')
                        }
                    </Typography>
                )}
            </div>
        </div>
    );
    
    // Create confirmation message
    const confirmationMessage = `Êtes-vous sûr de vouloir supprimer ${member.user_details?.full_name || member.user_details?.username || ''} de l'équipe ${member.team_name || ''} ? Cette action est irréversible.`;
    
    return (
        <MuiDialog
            open={open}
            onExternalClose={onClose}
            icon={<DeleteIcon />}
            title="Supprimer un membre d'équipe"
            subtitle={`Supprimer ${member.user_details?.full_name || member.user_details?.username || ''}`}
            content={dialogContent}
            existAction={true}
            actionTitle="Supprimer"
            actionFunction={handleDelete}
            isLoading={isLoading}
            maxWidth="sm"
            actionType="delete"
            confirmationMessage={confirmationMessage}
            showConfirmation={true}
            actions={
                <>
                    <Button onClick={onClose} color="inherit" disabled={isLoading}>
                        Fermer
                    </Button>
                    <Button 
                        onClick={handleDelete} 
                        color="error" 
                        variant="contained" 
                        disabled={isLoading}
                        startIcon={<DeleteIcon />}
                    >
                        Supprimer
                    </Button>
                </>
            }
        />
    );
};

export default DeleteMember;